<app-header />

<mat-sidenav-container class="sidenav-container">
  <mat-sidenav class="sidenav" mode="side" opened>
    <!-- Incidents Hub -->
    <mat-nav-list>
      @let navItem = categorizedItems['incidents-hub'][0];
      <a mat-list-item [routerLink]="[navItem.path]" routerLinkActive="active-link">
        <mat-icon class="icon">{{ navItem.icon }}</mat-icon
        ><span class="nav-item-label">{{ navItem.label }}</span>
      </a>
    </mat-nav-list>

    <!-- Insights -->
    <mat-expansion-panel togglePosition="before" expanded="true">
      <mat-expansion-panel-header>
        <mat-panel-title><span class="group-title">Insights</span></mat-panel-title>
      </mat-expansion-panel-header>
      <mat-nav-list>
        @for (navItem of categorizedItems['insights']; track navItem.label) {
          <a mat-list-item [routerLink]="[navItem.path]" routerLinkActive="active-link">
            <mat-icon class="icon">{{ navItem.icon }}</mat-icon
            ><span class="nav-item-label">{{ navItem.label }}</span>
          </a>
        }
      </mat-nav-list>
    </mat-expansion-panel>

    <!-- RIMS -->
    <mat-expansion-panel togglePosition="before" expanded="true">
      <mat-expansion-panel-header>
        <mat-panel-title><span class="group-title">RIMS</span></mat-panel-title>
      </mat-expansion-panel-header>
      <mat-nav-list>
        @for (navItem of categorizedItems['rims']; track navItem.label) {
          <a mat-list-item [routerLink]="[navItem.path]" routerLinkActive="active-link">
            <mat-icon class="icon">{{ navItem.icon }}</mat-icon
            ><span class="nav-item-label">{{ navItem.label }}</span>
          </a>
        }
      </mat-nav-list>
    </mat-expansion-panel>
  </mat-sidenav>

  <mat-sidenav-content id="content" class="content">
    <div [ngClass]="{ 'content-inner': true, loading: isLoading }">
      @if (isLoading) {
        <div class="spinner-wrapper">
          <mat-spinner class="spinner" [diameter]="64"></mat-spinner>
          <h5>Loading data...</h5>
        </div>
      }
      <div [ngClass]="{ page: true, loading: isLoading }">
        <router-outlet></router-outlet>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
